/**
 * @description 获取uShow模板列表
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IUShowTemplateListParams {
    size: number;
    page: number;
}

// 学习任务
export interface IUShowTemplate {
    id: string;
    template_type: string;
    template_name: string;
    pic_url: string;
    setup: {
        max_recommended_videos: number;
        ai_recommend_switch: number;
    };
    training_count: number;
    list_training_time: string;
}

export interface IUShowTemplateListRes {
    error_code: number;
    error_message: string;
    data: {
        page_info: {
            list_total_num: number;
            total_page_num: number;
            current_page: number;
            size: number;
        };
        list: IUShowTemplate[];
    }
}

export function getUShowTemplateList(data: IUShowTemplateListParams): Promise<IResponse<IUShowTemplateListRes>> {
    return fetchData(Api.U_SHOW_TEMPLATE_LIST, data).then((res: IResponse<IUShowTemplateListRes>) => {
        return res;
    });
}
